module.exports = __webpack_public_path__ + "img/About_One.2229bb71.jpg";